import React, { useState } from "react";
import PropTypes from "prop-types";
import { useMutation } from "react-apollo";
import { Title, Field, Control, Button, Fieldset } from "rbx";
import { useCurrentUser } from "../../utils/hooks";
import { ourToast as toast } from "../../utils";
import Loading from "../Loading";

import { VOID_WORK_ORDER_MUTATION } from "../../graphql/WorkOrders/WorkOrders.graphql";

import AvoidWorkOrderForm from "./VoidWorkOrderForm";

const INITIAL_STATE = {
  RecId: null,
  VoidReason: ""
};

const AvoidWorkOrderModal = ({ onComplete, WorkOrder }) => {
  const { data: user } = useCurrentUser();
  const [loading, setLoading] = useState(false);
  const [inputs, setInputs] = useState({
    ...INITIAL_STATE
  });

  const onChange = e => {
    setInputs({ VoidReason: e.target.value });
  };

  const [voidWorkOrder, voidWorkOrderData] = useMutation(
    VOID_WORK_ORDER_MUTATION,
    {
      refetchQueries: ["SINGLE_WORK_ORDER_QUERY", "ALL_WORK_ORDER_VIEW_QUERY"]
    }
  );

  const handleSave = async e => {
    e.preventDefault();
    try {
      if (user) {
        setLoading(true);
        const data = {
          VoidReason: inputs.VoidReason,
          VoidedByRecIdRef: parseInt(user.RecId, 10)
        };
        await voidWorkOrder({
          variables: {
            data,
            where: { RecId: WorkOrder.RecId }
          }
        });

        toast.success("Work Order Voided successfully.");
        setInputs({ ...INITIAL_STATE });
        onComplete();
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      toast.error(`Error voiding Work Order.`);
    }
  };
  if (loading || voidWorkOrderData.loading) return <Loading />;
  const canSaveOrEdit = !inputs.VoidReason;
  return (
    <form className="add-item-form" id="add-item-form" onSubmit={handleSave}>
      <Title>Are you sure you want to void this work order?</Title>
      <Fieldset disabled={loading}>
        <AvoidWorkOrderForm inputs={inputs} onChange={onChange} />
        <hr />
        <Field kind="group">
          <Control>
            <Button
              color="primary"
              disabled={canSaveOrEdit}
              form="add-item-form"
              type="submit"
            >
              Yes
            </Button>
          </Control>
          <Control>
            <Button type="button" onClick={onComplete}>
              No
            </Button>
          </Control>
        </Field>
      </Fieldset>
    </form>
  );
};

AvoidWorkOrderModal.propTypes = {
  onComplete: PropTypes.func,
  WorkOrder: PropTypes.object
};

AvoidWorkOrderModal.defaultProps = {
  WorkOrder: null
};

export default AvoidWorkOrderModal;
